import { computed } from "vue"
import { quota } from "~/utils/quota"
import { RenderingOverride } from "@pitchlane/shared"

export function useCanRenderVideos() {
    const canRenderVideos = computed(() => {
        // Avoid showing the blocked banner for a split second when the quota is loading.
        if (!quota.loaded) {
            return true
        }

        if (quota.loaded && quota.renderingOverride === RenderingOverride.BLOCK) {
            return false
        }
        return (
            (quota.loaded &&
                (quota.hasActiveSubscription ||
                    quota.isInTrial ||
                    (quota.scheduledCancellation &&
                        new Date(quota.scheduledCancellation) <= new Date()))) ||
            quota.renderingOverride === RenderingOverride.ALLOW
        )
    })

    return {
        canRenderVideos,
    }
}
